import { X } from "lucide-react";
import { useNewsStore } from "../../lib/newsStore";
import { NewsCard } from "./NewsCard";

const describe = (p) => [p.q && `"${p.q}"`, p.topic, p.province, p.city, p.side, p.ownership, p.source, p.indigenous && "Indigenous"].filter(Boolean).join(" · ") || "All news";

export const SavedView = ({ onApply, onOpenStory }) => {
  const { later, searches, removeSearch } = useNewsStore();
  return (
    <div className="space-y-10" data-testid="saved-news-view">
      <section>
        <h2 className="font-serif text-2xl text-slate-900">Saved searches</h2>
        <div className="mt-4 flex flex-wrap gap-3">
          {searches.length === 0 && <p className="text-sm text-slate-500" data-testid="saved-searches-empty">Use "Save" next to the search box in the feed to keep a search here.</p>}
          {searches.map((s) => (
            <div key={s.id} className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-white p-3" data-testid={`saved-search-${s.id}`}>
              <button onClick={() => onApply(s.params)} className="text-left"><span className="block font-medium text-slate-900">{s.name}</span><span className="text-xs text-slate-500">{describe(s.params)}</span></button>
              <button onClick={() => removeSearch(s.id)} className="text-slate-400 hover:text-rose-500" aria-label={`Delete ${s.name}`}><X size={16} /></button>
            </div>
          ))}
        </div>
      </section>
      <section>
        <h2 className="font-serif text-2xl text-slate-900">Read later · {later.length}</h2>
        <p className="mt-1 text-sm text-slate-500">Stored privately in this browser.</p>
        <div className="mt-4 grid gap-4 md:grid-cols-2 xl:grid-cols-3">{later.map((i) => <NewsCard key={i.id} item={i} onOpenStory={onOpenStory} />)}</div>
        {later.length === 0 && <p className="mt-4 text-sm text-slate-500" data-testid="read-later-empty">Tap the bookmark on any story to read it later.</p>}
      </section>
    </div>
  );
};
